export const GENDERS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "unisex", label: "Unisex" },
];

export const UNIFORM_VARIANTS = [
  { value: "regular", label: "Regular" },
  { value: "sports", label: "Sports" },
];

export const UNIFORM_SIZES = [
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
];

export const genderLabel = (value) => {
  if (value == null || value === "") return "";
  if (typeof value !== "string") {
    if (typeof value?.name === "string") return value.name;
    return value?._id ? String(value._id) : "";
  }
  return GENDERS.find((g) => g.value === value)?.label || value;
};

export const variantLabel = (value) => {
  if (value == null || value === "") return "";
  if (typeof value !== "string") return "";
  return UNIFORM_VARIANTS.find((v) => v.value === value)?.label || value;
};

/** Filter API dropdown values — rejects objects like {} that crash React when rendered. */
export const onlyNonEmptyStrings = (values) =>
  [...new Set((values || []).filter((v) => typeof v === "string" && v.trim()))].sort();

export const safeDisplay = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number") return String(value);
  return "";
};

export const toNumber = (value, fallback = 0) => {
  if (typeof value === "number" && !Number.isNaN(value)) return value;
  if (typeof value === "string" && value.trim()) {
    const n = parseFloat(value);
    return Number.isNaN(n) ? fallback : n;
  }
  return fallback;
};
